import React, {useMemo, useState} from 'react';
import { CustomPassword } from '../../../../components/CustomPassword';
import { PlusIconsOptions } from '../../../../components/buttons/IconButtons';
import ButtonAction from '../../../../components/buttons/ButtonAction';
import GeneralStepBody from "./GeneralStepBody";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 19 de 05 de 2026
 */
const CreatePassword = ({
                            t,
                            handleSavePassword,
                            password,
                            setPassword,
                            confirmPassword,
                            setConfirmPassword,
                            setTouched,
                            barClass,
                            allPassed,
                            ruleList,
                            ruleClass,
                            passwordsMatch,
                            canSave
}) => {

    return (
        <GeneralStepBody t={t} title='create_new_password' description='create_password_description'>
            <div className='d-flex flex-column text-center gap-3 mt-3 w-100'>
                <CustomPassword
                    id={'txt_cp_password'}
                    name={t('new_password')}
                    length={64}
                    label={'password'}
                    required={true}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    onKeyDown={() => setTouched(true)}
                />

                <div className='background-shades-100 w-100 p-3 border-radius-8px mt-3 mb-3'>
                    <div className='d-flex justify-content-between align-items-center w-100 gap-2'>
                        {[0, 1, 2, 3].map((i) => (
                            <div key={i} className={`${barClass(i)} flex-fill border-radius-2px`} />
                        ))}
                    </div>

                    <p className='fs-16px ibl-font-w-600 font-color-shades-700 mt-3 mb-3'>
                        {allPassed ? t('strong') : t('start_typing_to_check_strength')}
                    </p>

                    {ruleList.map(({ ok, label }, i) => (
                        <div key={label} className={`d-flex align-items-center gap-2 ${i < ruleList.length - 1 ? 'mb-2' : ''}`}>
                            <PlusIconsOptions className={ruleClass(ok)} />
                            <p className={`mb-0 fs-14px ${ruleClass(ok)}`}>{t(label)}</p>
                        </div>
                    ))}
                </div>

                <CustomPassword
                    id={'txt_cp_confirm_password'}
                    name={t('confirm_new_password')}
                    length={64}
                    label={'password'}
                    required={true}
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    isValid={confirmPassword.length === 0 || passwordsMatch}
                />

                <div className='col-12 mt-3 p-0 w-100'>
                    <ButtonAction
                        id='btn_ov_forgot_password'
                        name={'verify'}
                        disabled={!canSave}
                        className='btn-icon-add w-100'
                        onClick={() => {
                            handleSavePassword();
                        }}
                    />
                </div>
            </div>
        </GeneralStepBody>
    );
};

export default CreatePassword;
